module.exports = __webpack_public_path__ + "img/Machine.e8221ed8.svg";